// Xu hướng 12 tháng của 3 bộ phận (API Y1–Y3 V2), tải song song theo năm của kỳ đang xem.
import { useEffect, useState } from 'react';
import {
  getDashboardStatisticsV2, getSaleBranchStatisticsV2, getTelesaleStatisticsV2,
  type DashboardMonthStat, type SaleBranchStatisticsData, type TelesaleMonthStat,
} from 'api/DashboardStatistics';

export interface YearTrends {
  year: number;
  /** Khách hàng mới, lịch hẹn hoàn thành, doanh thu theo tháng (toàn công ty) */
  page: DashboardMonthStat[];
  /** Lịch hẹn mới / thành công / hủy theo tháng (Telesale) */
  tele: Record<string, TelesaleMonthStat>;
  /** Ca thành công theo chi nhánh + doanh thu nhóm S8 theo tháng (Sale cơ sở) */
  sale: SaleBranchStatisticsData | null;
  loading: boolean;
}

export function useYearTrends(year: number): YearTrends {
  const [state, setState] = useState<YearTrends>({ year, page: [], tele: {}, sale: null, loading: true });
  useEffect(() => {
    let ignore = false;
    setState(s => ({ ...s, loading: true }));
    Promise.all([getDashboardStatisticsV2(year), getTelesaleStatisticsV2(year), getSaleBranchStatisticsV2(year)]).then(([pg, ts, sb]) => {
      if (ignore) return;
      setState({
        year,
        page: pg.status && pg.data?.chart ? pg.data.chart : [],
        tele: ts.status ? ts.chart : {},
        sale: sb.status && sb.data ? sb.data : null,
        loading: false,
      });
    });
    return () => { ignore = true; };
  }, [year]);
  return state;
}
